import trustImage from "../pictures/trust-image.webp";
import atWork from "../pictures/at-work.webp";
import { NavLink } from "react-router";

export default function About() {
  return (
    <section id="about" className="max-w-[90%] xl:max-w-6xl mx-auto space-y-10">

      {/* Header */}
      <div className="space-y-4">
        <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
          About Us
        </div>
        <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
          Behind Every Fix.
        </h2>
        <p className="text-gray-500 text-lg leading-relaxed max-w-lg">
          Chicago Plumbing was built on one simple idea — give people a plumber they can actually rely on.
        </p>
      </div>

      {/* Main bento grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

        {/* Left — story card + 2 images */}
        <div className="flex flex-col gap-3">

          {/* Story card */}
          <div className="bg-white border border-gray-100 rounded-2xl p-7 shadow-sm space-y-4">
            <h3 className="font-black text-gray-900 text-xl tracking-tight">The Chicago Plumbing Way</h3>
            <p className="text-gray-500 text-sm leading-relaxed">
              Every job we take on gets the same treatment — a proper diagnosis, honest options, and work done with care. We don't cut corners, and we don't upsell you on things you don't need.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed">
              Our plumbers are licensed, experienced, and actually take pride in their work. That's what's kept clients calling us back for over 15 years.
            </p>
            <div className="flex items-center gap-3 pt-1">
              <div className="w-8 h-px bg-blue-200" />
              <span className="text-blue-400 text-xs font-bold tracking-widest uppercase">Licensed · Expert · Local</span>
            </div>
          </div>

          {/* 2 small images */}
          <div className="grid grid-cols-2 gap-3 flex-1">
           <div className="relative overflow-hidden rounded-2xl border border-gray-100 min-h-[180px] p-5 flex flex-col justify-between bg-white">
  <div className="absolute top-0 right-0 w-24 h-24 bg-blue-100 rounded-bl-[4rem] opacity-60" />

  <div className="relative z-10 space-y-2">
    <div className="inline-flex items-center gap-1.5 bg-blue-100 border border-blue-200 text-blue-700 text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full">
      Services
    </div>
    <h4 className="font-black text-gray-900 text-base leading-snug tracking-tight">
      What We Do
    </h4>
    <p className="text-xs text-gray-500 leading-relaxed">
      Repairs, installs, and emergency calls — done right the first time.
    </p>
  </div>

  <div className="relative z-10 flex items-center gap-1.5 mt-4">
    <NavLink to="/services" className="text-[10px] font-bold tracking-widest uppercase text-blue-500">See services</NavLink>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="text-blue-400">
      <path d="M2.5 6h7M6.5 3l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
</div>
             <div className="relative overflow-hidden rounded-2xl border group border-gray-100 min-h-[180px]">
              <img src={atWork} alt="On the job" className="absolute group-hover:scale-105 duration-300 transition-all inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute bottom-3 left-3">
                <p className="text-white font-bold text-sm">On the Job</p>
              </div>
            </div>
          </div>

        </div>

        {/* Right — tall image */}
        <div className="relative overflow-hidden rounded-2xl border border-gray-100 group min-h-[420px]">
          <img src={trustImage} alt="Chicago plumber" className="absolute inset-0 group-hover:scale-105 duration-300 transition-all w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6 space-y-2">
            <div className="inline-flex items-center gap-2 bg-blue-600/90 text-white text-xs font-bold tracking-widest uppercase px-3 py-1.5 rounded-full">
              Est. 2009 — Chicago, IL
            </div>
            <p className="text-white font-black text-xl leading-snug tracking-tight">
              15 years of showing up<br />and getting it done right.
            </p>
          </div>
        </div>

      </div>

      {/* Bottom quote strip */}
      <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm flex flex-col md:flex-row items-center gap-6">
        <div className="w-16 h-px bg-blue-200 md:w-px md:h-16 shrink-0" />
        <p className="font-black text-gray-900 text-xl md:text-2xl leading-relaxed text-center md:text-left tracking-tight">
          "We don't just fix pipes. We fix the problem — and leave your home the way we found it."
        </p>
      </div>

    </section>
  );
}